import { IRoute } from "../../../common/helpers/routesMapper";
import { seo } from "../../../common/helpers/seo";
import loadable from "./lazy";

export default {
    component: loadable,
    renderSeo: (store, allMessage, lang) => {
        return seo({ title: "Translate", allMessage, lang, type: "article" });
    },
} satisfies IRoute;
